import React, { useEffect, useState } from 'react';
import OpeningCapitalField from './OpeningCapitalField';


const AddOpeningCapital = () => {
     return (
        <div className='mx-auto w-full p-2 mt-8'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Add Opening Capital</h1>
            <OpeningCapitalField></OpeningCapitalField>
        </div>
    );
};

export default AddOpeningCapital;